﻿import {DateTime, translation} from "@2d-front-monorepo/core";
import {formatDate, formatTime, PermitResult} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";

export type PermitDatesProps = {
	permit: PermitResult;
	startDate?: DateTime;
	endDate?: DateTime;
};

export default function PermitDates(props: PermitDatesProps): JSX.Element {
	const {permit, startDate, endDate} = props;
	const start = startDate || permit.startDate;
	const end = endDate || permit.endDate;

	return (
		<div className="grid">
			<dl className="permit__date col-1of2">
				<dt>{translation(PermitTranslations.start_date)}</dt>
				<dd>
					<span>{formatDate(start.toDateOnly())}</span>
					<span>{formatTime(start.toTimeOnly())}</span>
				</dd>
			</dl>
			<dl className="permit__date col-1of2">
				<dt>{translation(PermitTranslations.end_date)}</dt>
				<dd>
					<span>{end && formatDate(end.toDateOnly())}</span>
					<span>{end && formatTime(end.toTimeOnly())}</span>
				</dd>
			</dl>
		</div>
	);
}
